
import React from "react";
import { Button } from "@/components/ui/button";

interface DashboardCardProps { 
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  description,
  icon,
  onClick
}) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
    <div className="flex items-center justify-between gap-4 mb-4">
      <div className="flex items-center text-slate-900">
        {icon}
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="h-auto px-3 text-sm text-[#FF5605] hover:text-[#e34b00]"
      >
        Gerenciar
      </Button>
    </div>
    <p className="text-sm text-slate-600">{description}</p>
  </div>
);

export default DashboardCard;
